export default "__VITE_ASSET__95efb557__"